/**
 * /xyz 後台管理輔助（P0.5）
 * ADMIN_TOKEN 與 Worker env.ADMIN_TOKEN 對應（wrangler secret put ADMIN_TOKEN）；
 * 寫入操作（刪除 leads、登記/刪除推薦碼）需帶 x-admin-token header。
 * token 存 localStorage（本機後台使用，不部署到公開頁面）。
 */

const CF_WORKER_URL = 'https://jkd-whatsapp-verification.jimsbond007.workers.dev';
const TOKEN_KEY = 'jkd_admin_token';

export function getAdminToken(): string {
  try {
    return localStorage.getItem(TOKEN_KEY) || '';
  } catch {
    return '';
  }
}

export function setAdminToken(token: string): void {
  try {
    localStorage.setItem(TOKEN_KEY, token);
  } catch {
    /* ignore */
  }
}

/** 取得 token，若未設定則彈出輸入框（一次性，之後存 localStorage） */
export function requireAdminToken(): string {
  let token = getAdminToken();
  if (!token) {
    token = window.prompt('請輸入 Admin Token（wrangler secret ADMIN_TOKEN，只需輸入一次）') || '';
    if (token) setAdminToken(token);
  }
  return token;
}

/** 帶 token 的寫入請求；401 時清除已存 token 並提示重輸 */
export async function adminFetch(path: string, init: RequestInit = {}): Promise<Response> {
  const doFetch = (token: string) =>
    fetch(`${CF_WORKER_URL}${path}`, {
      ...init,
      headers: { 'Content-Type': 'application/json', 'x-admin-token': token, ...(init.headers || {}) },
    });

  let res = await doFetch(requireAdminToken());
  if (res.status === 401) {
    setAdminToken(''); // 清除錯誤 token，requireAdminToken 會重新詢問
    res = await doFetch(requireAdminToken());
  }
  return res;
}
